import { fetchJSON } from '@bonnet/next/fetch';

const errorObject = {
    error: 'Circuit Breaker for /smart-search-suggestions/query is open',
};

export default (data = {}) => {
    const { selectedFilterOptions, personalizationData, pixallId, consumerId, ...rest } = data;
    const options = {
        body: {
            selectedFilterOptions,
            personalizationData,
            pixallId,
            consumerId,
            ...rest,
        },
        method: 'POST',
        circuitBreaker: {
            id: 'smart-search-suggestions',
            timeout: 5000,
            resetTimeout: 30000,
            fallback: errorObject,
        },
    };
    return fetchJSON('/smart-search-suggestions/query', options);
};
